import { formatMv2LastUpdated } from "@/features/_mv2/mv2Freshness";

/**
 * Compact, non-blocking companion to {@link usePollFreshness}: only renders
 * while a poll is actively failing to reach the server, so a normal
 * successful poll never shows anything.
 */
export default function PollStaleNotice({ isStale, lastSuccessMs, className = "" }) {
  if (!isStale || !lastSuccessMs) return null;

  const label = formatMv2LastUpdated(lastSuccessMs, Date.now());

  return (
    <div
      role="status"
      data-testid="poll-stale-notice"
      className={`flex items-center gap-2 rounded-2xl border border-[#EBB3A9]/60 bg-[#EEEBD0]/60 px-3 py-1.5 text-xs text-[#2D2D2D]/80 ${className}`.trim()}
    >
      <span aria-hidden="true">⚠</span>
      <span>Showing data from {label} — reconnecting…</span>
    </div>
  );
}
